export enum BoughtInquiryStatus {
  UNKNOWN = 0,
  OPEN = 10,
  SENT = 20,
  ACCEPTED = 30,
  REJECTED = 40,
  COMPLETED = 50,
  DELETED = 60,
}
